module.exports = __webpack_public_path__ + "static/media/india.16aee32a.svg";